import * as React from 'react';
import { observer } from 'mobx-react';
import './eventDetailsPage.module.scss';

import { EyeCatch } from './components/EyeCatch';
import { Menu } from './components/Menu';
import { EventDescription } from './components/EventDescription';
import { observable } from 'mobx';
import { DetailsPageState } from './states/DetailsPageState';
import { NotFoundPage } from '../common/NotFoundPage';
import { GlobalLoader } from '../../components/GlobalLoader';
import { CoachProfile } from '../common/coach/CoachProfile';
import { viewportState } from '../../../commonv2/states/globalStates';
import { EventDetailsSection } from './components/EventDetailsSection';
import { FloatingEventInfo } from './components/FloatingEventInfo';
import { GlobalStates } from '../../states/globalStates';
import { withNavigation } from '../../../mainv3/components/hocs/withNavigation';
import { NavigationSpecs } from '../../../mainv3/states/NavigationState';

type Props = {
    match: {
        params: {
            eventId: string;
        };
    };
};

@withNavigation(NavigationSpecs.standard())
@observer
export default class EventDetailsPage extends React.Component<Props> {
    @observable pageState = new DetailsPageState();
    async componentDidMount() {
        const { eventId } = this.props.match.params;
        await this.pageState.init(Number(eventId), GlobalStates.currentUser);
    }
    render() {
        const { event, alreadyReserved, membershipAvailable, appliedPrice } = this.pageState;
        if (event.isNotFound()) {
            return <NotFoundPage entityType="イベント" />;
        }
        if (event.loading) {
            return <GlobalLoader />;
        }
        const mobile = viewportState.isMobile;
        return (
            <div styleName="course-details-page">
                <EyeCatch event={event.getOrThrow()} alreadyReserved={alreadyReserved} />

                {!mobile && <Menu />}

                <div styleName="two-columns-container">
                    <div styleName="right-column">
                        <FloatingEventInfo
                            event={event.getOrThrow()}
                            alreadyReserved={alreadyReserved}
                            membershipAvailable={membershipAvailable}
                            appliedPrice={appliedPrice}
                        />
                    </div>
                    {mobile && <Menu />}
                    <div styleName="left-column">
                        <EventDetailsSection id="overview" title="イベント概要">
                            <EventDescription event={event.getOrThrow()} />
                        </EventDetailsSection>
                        <EventDetailsSection id="coaches" title="講師紹介">
                            {event.getOrThrow().coaches.map((coach) => <CoachProfile key={coach.id} coach={coach} />)}
                        </EventDetailsSection>
                    </div>
                </div>
            </div>
        );
    }
}
